// Display labels for carrier enum-ish values. The backing values live in the
// carriers table (routing_type CHECK; lines_of_business is free-form text[]).
export const LINE_LABELS = {
  hull_liability: 'Hull & Liability',
  hangar: 'Hangar',
  property: 'Property',
  general_liability: 'General Liability',
};

export const ROUTING_LABELS = {
  api: 'API',
  direct_email: 'Direct email',
  via_cobroker: 'Via co-broker',
  portal: 'Portal',
};
